import { httpRootClient } from './httpClient';

const baseEndPoint =
  process.env.NODE_ENV === 'production' ? process.env.VUE_APP_PUBLIC_PATH : '/';

const visualResources = () => httpRootClient.get(`${baseEndPoint}menu/sources`);

export default {
  visualResources,
};
